"use client";

import { SearchForm } from "@/app/search-form";
import { Suspense } from "react";

export function Top({ showSearch = true }: { showSearch?: boolean }) {
  return (
    <Suspense>
      <SearchForm showSearch={showSearch} />
    </Suspense>
  );
}
